module.exports = __webpack_public_path__ + "img/denmark.be60e04c.svg";